import styled from 'styled-components'
// import { usePage } from 'frontend/src/contexts/PageUse';
import UtilWrapper from 'frontend/src/components/util/UtilWrapper';
import SidebarContainer from 'frontend/src/components/sidebar/SidebarContainer';
import { usePage } from '../../contexts/PageProvider';
import { TypeBodyM } from '../../styles/mixins';
import { Columns } from '../../styles/functions';
import SanityContent from '../sanity/content/SanityContent';
import PageLanding from './PageLanding';
import PageFooter from './PageFooter';

function PageEditorial() {
  const page = usePage();

  return (
    <>
    <Container>
      { page.layout == 'editorial.landing' && <Landing />}
      { page.layout == 'editorial.sidebar' && <Sidebar isSticky={false} />}
      
      {
        page.editorialContent && 
        <Content 
          layout="EDITORIAL" 
          blocks={page.editorialContent}  
        />
      }
    </Container>
    <PageFooter />
    </>
  )
}

const Container = styled(UtilWrapper)`
margin-top: var(--spacing-page-top);
`

const Sidebar = styled(SidebarContainer)`
`

const Landing = styled(PageLanding)`

`

const Content = styled(SanityContent)`
  ${TypeBodyM}
`

export default PageEditorial
